/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import AuthGuard from './components/AuthGuard'
import AuthLayout from './layouts/Auth';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';
import OverviewView from './views/Overview';

const routes = [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/overview" />
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: lazy(() => import('views/Login'))
      },
      {
        path: '/auth/lostPassword',
        exact: true,
        component: lazy(() => import('views/LostPassword'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-401',
        exact: true,
        component: lazy(() => import('views/Error401'))
      },
      {
        path: '/errors/error-404',
        exact: true,
        component: lazy(() => import('views/Error404'))
      },
      {
        path: '/errors/error-500',
        exact: true,
        component: lazy(() => import('views/Error500'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/management/users',
    component: (props) => <AuthGuard roles={[ 'admin' ]}><DashboardLayout {...props}/></AuthGuard>,
    routes: [
      {
        path: '/management/users',
        exact: true,
        component: lazy(() => import('views/UserManagementList'))
      },
      {
        path: '/management/users/:id',
        exact: true,
        component: lazy(() => import('views/UserManagementDetails'))
      },
      {
        path: '/management/users/:id/:tab',
        exact: true,
        component: lazy(() => import('views/UserManagementDetails'))
      },
    ]
  },
  {
    path: '/management/parkings',
    component: (props) => <AuthGuard roles={[ 'admin', 'partner' ]}><DashboardLayout {...props}/></AuthGuard>,
    routes: [
      {
        path: '/management/parkings',
        exact: true,
        component: lazy(() => import('views/ParkingsList'))
      },
      {
        path: '/management/parkings/create',
        exact: true,
        component: lazy(() => import('views/ParkingCreate'))
      },
      {
        path: '/management/parkings/:id',
        exact: true,
        component: lazy(() => import('views/ParkingDetails'))
      },
      {
        path: '/management/parkings/:id/edit',
        exact: true,
        component: lazy(() => import('views/ParkingEdit'))
      },
      {
        path: '/management/parkings/:id/:tab',
        exact: true,
        component: lazy(() => import('views/ParkingDetails'))
      },
    ]
  },
  {
    path: '/management/withdrawals',
    component: (props) => <AuthGuard roles={[ 'admin', 'partner', 'agence' ]}><DashboardLayout {...props}/></AuthGuard>,
    routes: [
      {
        path: '/management/withdrawals',
        exact: true,
        component: lazy(() => import('views/WithdrawalsList'))
      },
      {
        path: '/management/withdrawals/:id',
        exact: true,
        component: lazy(() => import('views/WithdrawalDetails'))
      },
      {
        path: '/management/withdrawals/:id/:tab',
        exact: true,
        component: lazy(() => import('views/WithdrawalDetails'))
      },
    ]
  },
  {
    path: '/management/referred',
    component: (props) => <AuthGuard roles={[ 'agence' ]}><DashboardLayout {...props}/></AuthGuard>,
    routes: [
      {
        path: '/management/referred',
        exact: true,
        component: lazy(() => import('views/ReferredList'))
      },
    ]
  },
  {
    route: '*',
    component: (props) => <AuthGuard roles={[ 'admin', 'partner', 'gate_manager', 'agence' ]}><DashboardLayout {...props}/></AuthGuard>,
    routes: [
      {
        path: '/management/bookings',
        exact: true,
        component: lazy(() => import('views/Bookings'))
      },
      {
        path: '/management/bookings/:id',
        exact: true,
        component: lazy(() => import('views/BookingDetails'))
      },
      {
        path: '/management/bookings/:id/:tab',
        exact: true,
        component: lazy(() => import('views/BookingDetails'))
      },
      {
        path: '/overview',
        exact: true,
        component: OverviewView
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];

export default routes;
